import ActionToggle from "features/social-toggles/blocks/ActionToggle";
import { useFlag } from "hooks/useFlags";
import { useUser } from "hooks/useUser";
import React from "react";

type AdminButtonsProps = {
  cardContentType: string | undefined;
  cardContentId: string;
  isDeletedCurrent: boolean;
  setIsDeletedCurrent: (v: boolean) => void;
  isModeratedCurrent: boolean;
  setIsModeratedCurrent: (v: boolean) => void;
  onStatusChange?: () => void;
};

const AdminButtons: React.FC<AdminButtonsProps> = ({
  cardContentType,
  cardContentId,
  isDeletedCurrent,
  setIsDeletedCurrent,
  isModeratedCurrent,
  setIsModeratedCurrent,
  onStatusChange,
}) => {
  const moderationEnabled = useFlag("moderationEnabled");
  const { isModerator } = useUser();
  const canModerate = isModerator && moderationEnabled;

  if (!canModerate) return null;

  return (
    <>
      <ActionToggle
        kind="delete"
        objectType={cardContentType}
        objectId={cardContentId}
        isActive={isDeletedCurrent}
        onToggle={() => {
          setIsDeletedCurrent(!isDeletedCurrent);
          onStatusChange?.();
        }}
      />
      <ActionToggle
        kind="moderate"
        objectType={cardContentType}
        objectId={cardContentId}
        isActive={isModeratedCurrent}
        onToggle={() => {
          setIsModeratedCurrent(!isModeratedCurrent);
          onStatusChange?.();
        }}
      />
    </>
  );
};

export default AdminButtons;
